import React from 'react';

export const ModerateIcon = (props: any) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
            <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2ZM9.31,17a.61.61,0,0,1-.85,0L7.05,15.54a.61.61,0,0,1,0-.85l7.64-7.64a.61.61,0,0,1,.85,0L17,8.46a.61.61,0,0,1,0,.85Z"/>
        </svg>
    )
}
